import { MouseEvent } from "react";
import { IconButton } from "@material-ui/core";
import { getPointColorFromString } from "@Utils/colorPicker";

type StopFactorIndicatorProps = {
  /** null/undefined — не считали */
  count: number | null | undefined;
  onClick: () => void;
};

// Кружок и отступ повторяют ColorButton в соседних колонках: видимый круг 16px, кнопка 48px с тем же ховером.
const SIZE = 16;
const BUTTON_PADDING = 16;

const getColor = (count: number | null | undefined) => {
  if (count == null) return "gray";
  return count > 0 ? "red" : "green";
};

const StopFactorIndicator = ({ count, onClick }: StopFactorIndicatorProps) => {
  const handleClick = (event: MouseEvent) => {
    event.preventDefault();
    event.stopPropagation();
    onClick();
  };

  const showCount = count != null && count > 1;

  return (
    <IconButton onClick={handleClick} style={{ padding: BUTTON_PADDING }}>
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          minWidth: SIZE,
          height: SIZE,
          padding: showCount && count > 9 ? "0 3px" : 0,
          borderRadius: SIZE / 2,
          boxSizing: "border-box",
          background: getPointColorFromString(getColor(count)),
          color: "#fff",
          fontSize: 10,
          fontWeight: 700,
          lineHeight: 1,
        }}
      >
        {showCount ? count : null}
      </span>
    </IconButton>
  );
};

export default StopFactorIndicator;
